import React from 'react';
import { LayersControl, TileLayer } from 'react-leaflet';
import { map as mapConfig } from '../../app/config';

const Layers = ({ position = 'bottomleft' }) => (
  <LayersControl position={position}>
    <LayersControl.BaseLayer checked name="Default">
      <TileLayer
        attribution={mapConfig.primaryTileLayerAttribution}
        url={mapConfig.primaryTileLayerUrl}
      />
    </LayersControl.BaseLayer>
    <LayersControl.BaseLayer name="Satellite">
      <TileLayer
        attribution={mapConfig.secondaryTileLayerAttribution}
        url={mapConfig.secondaryTileLayerUrl}
      />
    </LayersControl.BaseLayer>
  </LayersControl>
);

export default Layers;
